import { Link } from 'react-router-dom';
import Layout from '@/components/layout/Layout';
import { Button } from '@/components/ui/button';
import { Store, Sparkles, ArrowRight } from 'lucide-react';

/**
 * Directorio de proveedores — **no habilitado en este release**. Cualquier acceso a
 * `/vendors` (nav, categorías del landing, enlaces con `?category=`) aterriza en este
 * estado "próximamente". El backoffice de proveedores es un flujo aparte.
 */
const Vendors = () => {
  return (
    <Layout>
      <div className="bg-romantic min-h-screen">
        <div className="container mx-auto px-4 py-20 sm:py-28">
          <div className="max-w-xl mx-auto text-center">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-primary/10 text-primary mb-6">
              <Store className="w-8 h-8" />
            </div>

            <div className="inline-flex items-center gap-1.5 text-xs font-medium tracking-widest uppercase text-muted-foreground mb-3">
              <Sparkles className="w-3.5 h-3.5 text-gold" />
              Próximamente
            </div>

            <h1 className="font-serif text-3xl sm:text-4xl md:text-5xl font-semibold text-foreground mb-4">
              El directorio de proveedores llega pronto
            </h1>

            <p className="text-muted-foreground text-base sm:text-lg leading-relaxed mb-8">
              Estamos seleccionando a los mejores profesionales de bodas —lugares, catering,
              fotografía, música y más— para que los descubras y contactes directamente desde
              aquí, sin intermediarios. Aún no está disponible, pero falta poco.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <Button asChild size="lg">
                <Link to="/dashboard">
                  Mientras tanto, crea tu invitación
                  <ArrowRight className="w-4 h-4 ml-2" />
                </Link>
              </Button>
              <Button asChild variant="ghost" size="lg">
                <Link to="/">Volver al inicio</Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Vendors;
